import { Component, OnInit } from '@angular/core';
import { PessoaTipoLabels } from '@tivic-team/manager-ts/dist/grl/enums/pessoa-tipo.enum';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'dropdown-tipo-pessoa',
  templateUrl: './dropdown-tipo-pessoa.component.html',
  styleUrls: ['./dropdown-tipo-pessoa.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownTipoPessoaComponent implements OnInit {

  pessoaTipo = PessoaTipoLabels;

  constructor() {}

  ngOnInit() {}

}
